import { FileText, MessageCircle, Smartphone, UsersRound, type LucideIcon } from 'lucide-react';
import { WHATSAPP_SURFACES, type ConversationSurface } from '@/lib/api';

export interface SurfaceMeta {
  /** O nome da origem (tag, title do histórico): o usuário pediu exatamente estes quatro. */
  label: string;
  icon: LucideIcon;
}

/**
 * Uma origem, um nome e um ícone. Os ícones repetem os do resto do console
 * (Conhecimento na navegação, a Shiba no menu da conta) para a tag ser reconhecida sem
 * ser lida.
 */
export const SURFACES: Record<ConversationSurface, SurfaceMeta> = {
  knowledge: { label: 'Conhecimento', icon: FileText },
  chatbot: { label: 'Chat', icon: MessageCircle },
  whatsapp_direct: { label: 'WhatsApp Direta', icon: Smartphone },
  whatsapp_group: { label: 'WhatsApp Grupo', icon: UsersRound },
};

/** A conversa é do bot do WhatsApp: o console a fixa, mas não a renomeia nem a exclui. */
export function isWhatsAppSurface(surface: ConversationSurface): boolean {
  return WHATSAPP_SURFACES.includes(surface);
}

/** Onde uma conversa se abre: na tela dedicada ao Chat. */
export function conversationPath(id: string): string {
  return `/app/chat?conversa=${encodeURIComponent(id)}`;
}

/** O "Novo chat": a conversa só é criada no primeiro envio. */
export const NEW_CONVERSATION_PATH = '/app/chat?conversa=nova';
